import './style.css';


export const RECATCHA_V2_PUBLIC_KEY = '6Levj6UZAAAAAGPjgbETeI23JwO4wvukqgjazdAh';
export const RECATCHA_V3_PUBLIC_KEY = '6LcUpGIiAAAAAD0a3aTUyYfG2Jn8mQq65DJFBMyh';


// Caricamento dello script una sola volta globalmente
if (!window.__RECAPTCHA_SCRIPT_ADDED) {
    window.__RECAPTCHA_SCRIPT_ADDED = true;

    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${RECATCHA_V3_PUBLIC_KEY}`;
    document.head.appendChild(script);

    // From official docs @see https://developers.google.com/recaptcha/docs/loading
    // How this code snippet works:
    // This logic overwrites the default behavior of `grecaptcha.ready()` to
    // ensure that it can be safely called at any time. When `grecaptcha.ready()`
    // is called before reCAPTCHA is loaded, the callback function that is passed
    // by `grecaptcha.ready()` is enqueued for execution after reCAPTCHA is
    // loaded.
    if(typeof window.grecaptcha === 'undefined') {
        window.grecaptcha = {
            ready: function(cb) {
                // window.__grecaptcha_cfg is a global variable that stores reCAPTCHA's
                // configuration. By default, any functions listed in its 'fns' property
                // are automatically executed when reCAPTCHA loads.
                const c = '___grecaptcha_cfg';
                window[c] = window[c] || {};
                (window[c]['fns'] = window[c]['fns'] || []).push(cb);
            }
        };
    }

}

export function waitForRecaptchaLoaded(){
    return new Promise(r => {
        if (window.grecaptcha && window.grecaptcha.execute){
            r();
        }else{
            window.grecaptcha.ready(_ => r());
        }
    });
}
